import actionConstants from '../constants/';

const imeiTransactionList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};
const getImeiDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};
const imeiValidationDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};
const manageBlockImeiState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  responseCode: 0,
  responseMessage: '',
};

const initialState = {
  imeiTransactionList: { ...imeiTransactionList },
  getImeiDetails: { ...getImeiDetails },
  imeiValidationDetails: { ...imeiValidationDetails },
  manageBlockImeiState: { ...manageBlockImeiState },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function imeiTransactionReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_EDGE_IMEI_TRANSACTION_REQUEST:
      return {
        ...state,
        imeiTransactionList: {
          ...state.imeiTransactionList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_EDGE_IMEI_TRANSACTION_SUCCESS:
      return {
        ...state,
        imeiTransactionList: {
          ...state.imeiTransactionList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.GET_EDGE_IMEI_TRANSACTION_FAILURE:
      return {
        ...state,
        imeiTransactionList: {
          ...state.imeiTransactionList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: []
        },
      };

    case actionConstants.GET_EDGE_IMEI_TRANSACTION_CLEAR:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isFailure: false,
        imeiTransactionList: {
          ...initialState.imeiTransactionList,
          data: {},
        },
      };
    case actionConstants.GET_EDGE_IMEI_TRANSACTION_DETAILS_REQUEST:
      return {
        ...state,
        getImeiDetails: {
          ...state.getImeiDetails,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_EDGE_IMEI_TRANSACTION_DETAILS_SUCCESS:
      return {
        ...state,
        getImeiDetails: {
          ...state.getImeiDetails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_EDGE_IMEI_TRANSACTION_DETAILS_FAILURE:
      return {
        ...state,
        getImeiDetails: {
          ...state.getImeiDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_EDGE_IMEI_TRANSACTION_DETAILS_CLEAR:
      return {
        ...state,
        getImeiDetails: {
          ...state.getImeiDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
        },
      };
    case actionConstants.GET_EDGE_IMEI_VALIDATION_DETAILS_REQUEST:
      return {
        ...state,
        imeiValidationDetails: {
          ...state.imeiValidationDetails,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_EDGE_IMEI_VALIDATION_DETAILS_SUCCESS:
      return {
        ...state,
        imeiValidationDetails: {
          ...state.imeiValidationDetails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_EDGE_IMEI_VALIDATION_DETAILS_FAILURE:
      return {
        ...state,
        imeiValidationDetails: {
          ...state.imeiValidationDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_EDGE_IMEI_VALIDATION_DETAILS_CLEAR:
      return {
        ...state,
        imeiValidationDetails: {
          ...initialState.imeiValidationDetails,
          data: {},
        },
      };
    case actionConstants.POST_IMEI_BLOCK_REQUEST:
      return {
        ...state,
        manageBlockImeiState: {
          ...state.manageBlockImeiState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          responseCode: 0,
          responseMessage: '',
        },
      };
    case actionConstants.POST_IMEI_BLOCK_SUCCESS:
      return {
        ...state,
        manageBlockImeiState: {
          ...state.manageBlockImeiState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          responseCode: 0,
          responseMessage: action?.payload?.body?.message,
        },
      };
    case actionConstants.POST_IMEI_BLOCK_FAILURE:
      return {
        ...state,
        manageBlockImeiState: {
          ...state.manageBlockImeiState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          responseCode: 0,
          responseMessage:
            action?.payload?.body?.error_details?.error?.message ||
            action?.payload?.body?.error_details?.[0]?.product_brand_response?.message ||
            action?.payload?.body?.message,
        },
      };
    case actionConstants.POST_IMEI_BLOCK_CLEAR:
      return {
        ...state,
        manageBlockImeiState: {
          ...state.manageBlockImeiState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          responseCode: 0,
          responseMessage: '',
        },
      };

    default:
      return state;
  }
}




